/**
 * FeatureName tracks all the features for which we show messages in our product.
 */ export var FeatureName = /*#__PURE__*/ function(FeatureName) {
    FeatureName["FEATURE_NAME_UNKNOWN"] = "FEATURE_NAME_UNKNOWN";
    FeatureName["FIRST_ORDER_INCENTIVE"] = "FIRST_ORDER_INCENTIVE";
    FeatureName["BLOCKED_CHECKOUT"] = "BLOCKED_CHECKOUT";
    return FeatureName;
}({});
